window.addEventListener("page:reload", (event) => {
  window.location.reload()
})
